(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/side-nav/assets/javascripts/lazy-winnerstories.js') >= 0) return;  svs.modules.push('/components/tipsen/side-nav/assets/javascripts/lazy-winnerstories.js');
"use strict";

const {
  tipsenLazy
} = svs.components.tipsen.tipsenLazy;
const LazyWinnerstories = tipsenLazy('/cl/tipsen/route-winnerstories', () => svs.components.tipsen.routeWinnerstories.RouteWinnerstories);
setGlobal('svs.components.tipsen.sideNav.LazyWinnerstories', LazyWinnerstories);

 })(window);